import React, { Suspense } from 'react';
import { intakeDevToolsEnabled } from './flag';

/**
 * Punto de entrada de las herramientas de desarrollo del intake.
 *
 * Todo lo pesado (paneles, relleno, engine) cuelga de este `lazy`: con la
 * bandera apagada el `import()` no se ejecuta nunca y el chunk no se descarga,
 * aunque el archivo exista en la salida del build.
 *
 * Dos montajes porque el árbol de la app está partido: `/status/*` (portal del
 * cliente) vive fuera del `QuoteProvider` y el resto adentro. El modo decide
 * qué panel se dibuja.
 */
const DevToolsShell = React.lazy(() => import('./DevToolsShell'));

export type IntakeDevToolsMode = 'application' | 'portal';

export function IntakeDevTools({ mode }: { mode: IntakeDevToolsMode }) {
  if (!intakeDevToolsEnabled()) return null;
  return (
    <Suspense fallback={null}>
      <DevToolsShell mode={mode} />
    </Suspense>
  );
}

export default IntakeDevTools;
